import { temporarilyNotSupport } from '../../utils'

// 地图
export const createMapContext = temporarilyNotSupport('createMapContext')
